import { render, staticRenderFns } from "./HomeGuide.vue?vue&type=template&id=d763c2de&scoped=true&"
import script from "./HomeGuide.vue?vue&type=script&lang=js&"
export * from "./HomeGuide.vue?vue&type=script&lang=js&"
import style0 from "./HomeGuide.vue?vue&type=style&index=0&id=d763c2de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d763c2de",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CategoryList: require('/var/www/mbm.garena.all/frontend/components/CategoryList.vue').default,Loading: require('/var/www/mbm.garena.all/frontend/components/Loading.vue').default,BannerSwiper: require('/var/www/mbm.garena.all/frontend/components/BannerSwiper.vue').default})
